<template>
  <div class="page-brand__right">
    <div class="headerBrand">
      <div class="headerBrandContainer">
        <div class="page-brand__right-top-text" v-if="brand && brand.client">
          <div class="textTitle">
            <router-link :to="'/client/'+brand.client.slug" class="routeLinkGroup routeLinkHeader ">
              <span class="textTitleGrey">{{ brand.client.name }}</span>
            </router-link>
              <span class="textTitleGrey" style="margin: 0 0.5ch;">/</span>
              <span class="textTitlesilver">{{ brand.name }}</span>
          </div>
          <editBrand title="Edit Brand" :client="brand.client" :brand="brand" v-if="accountView"/>
        </div>
        <div class="button-underline"></div>

        <div class="button-group-wrap">
                  <newCampaignBTN
                v-if="accountView"
                :brand="brand"                
          />
          <div class="button-group" v-if="brand && brand.campaign">
            <button
                class="file-button"
                v-for="(camp, idx) in brand.campaign"
                :key="camp.id"
                @click="selected_campaign_id = camp.id; selected_board_id = camp.board[0].id"
                :class="{'active' : selected_campaign_id == camp.id || selected_campaign.id === camp.id || (selected_campaign_id ==false && !selected_campaign && idx == 0)}"
            >
              {{ camp.name }}
            </button>         
          </div>
  
        </div>
        <div v-if="selected_campaign" class="button-underline"></div>
      </div>

      <div class="file-name-group" v-if="selected_campaign">
        <div class="brandTitleText">{{ selected_campaign.name }}</div>
        <editCampaign v-if="accountView" :campaign="selected_campaign" :campaign_name="selected_campaign.name"/>
      </div>
    </div>

    <div class="page-brand__right-content" v-if="selected_campaign">
      <div class="page-brand__right-content-boards">
        <h3>Boards</h3>
        <div class="board-content">
          <div v-if="selected_campaign.board">
            <div
                class="brand-board"
                v-for="(board,idx) in selected_campaign_board"
                :key="board.id"
                @click="selected_board_id = board.id"
                :class="{'active' : selected_board_id == board.id || selected_board.id === board.id ||  (selected_board_id == false && !selected_board && idx == 0)}"
            >
              <div class="brand-board-name">{{ board.name }}</div>
              <div class="brand-board-count" >
                <span>{{ doneOnBoard(board) }}</span
                >/
                <span v-if="accountView">{{ board.creative ? board.creative.length : 0 }}</span>
                <span v-else>{{ board.creative ? board.creative.filter(creative=> creative.status == 'live' || creative.status == 'done').length : 0 }}</span>
              </div>
            </div>

          </div>
          <newBoardBTN
              v-if="accountView"
              :campaign="selected_campaign"
              style="margin-top: 20px;"
          />
        </div>
      </div>    
      <div class="page-brand__right-content-static" v-if="selected_campaign">
        <div v-if="selected_board" class="page-brand__right-content-static-txt">
          <h3>{{ selected_board.name }}</h3>
          <div v-if="accountView" class="flex-row">
            <edit-board v-if="accountView" :brand="brand" :board="selected_board"/>
            <button v-if="!copyLinkAnim" class="client-copy-link-color-board" @click="copyLink('/brand/'+selected_campaign.brand.slug+'/'+selected_board.campaign.slug+'/'+selected_board.slug)">
              <img alt="Edit Button" src="@/assets/img/icons/clone.svg"> copy board link              
            </button>
            <!-- animated state -->
            <div v-else class="animCopyLink client-copy-link-color-board">              
              <div><img alt="Edit Button" src="@/assets/img/icons/ic-blue-check.svg"></div>
            </div>
            <input type="hidden" id="testing-code" :value="testingCode">
          </div>
        </div>

        <!--<div class="page-brand__right-content-static-copy">
          <LinkCopier />
        </div>-->
        <div v-if="selected_board" class="underline-for-board"></div>

        <div
            class="page-brand__right-content-static-contact"
            v-if="accountView && selected_board"
        >
          <div v-if="selected_board" class="flex-column margin-small--right">
            <md-field>                      
              <label>Clients to notify</label>                                    
              <own-custom-select v-model="boardUserToNotify" :placeholder='"Choose..."' multiple @change="setUserOnBoard()">
                <own-custom-select-option 
                    v-for="user in clients"
                    :key="user.id"
                    :value="user.id"                      
                >                
                  {{user.name}}
                </own-custom-select-option>                
              </own-custom-select>                      
            </md-field>         
          </div>
          <div v-if="selected_board" class="flex-column margin-small--left">
            <md-field>     
              <label>Accounts to notify</label>             
              <own-custom-select v-model="boardUserToNotify" :placeholder='"Choose..."' multiple @change="setUserOnBoard()">
                  <own-custom-select-option 
                      v-for="user in notclients"
                      :key="user.id"
                      :value="user.id"                      
                  >                
                    {{user.name}}
                  </own-custom-select-option>                
                </own-custom-select>   
            </md-field>
          </div>
        </div>
        <div v-if="selected_board && !accountView" class="md-layout container-for-names">
          <div class="md-layout-item"  >
            <h4>Clients on board:</h4>
            <div v-for="u in selected_board.user" :key="u.id" class="user-on-board">
              <span v-if="u.user_type == 'client'">{{ u.name }},</span>
            </div>
          </div>
          <div class="md-layout-item">
            <h4>Accounts on board:</h4>
            <div v-for="u in selected_board.user" :key="u.id">
              <div class="font-size-fourteen" v-if="u.user_type == 'account' || u.user_type == 'administrator'">
                {{ u.name }}
              </div>
            </div>
          </div>
        </div>       
        <div v-if="selected_board" class="page-brand__right-content-static-cards">
          <FilterComponent
              :board="selected_board"
              :brand="brand"
              :campaign="selected_campaign"
              :accountView="accountView"
              :designerView="designerView"
          />
        </div>
        <div v-if="!selected_board" class="empty-message">
          <span v-if="accountView">Add a new board</span>
          <span v-else>No boards</span>
        </div>
      </div>
    </div>
    <div v-if="selected_campaign" class="action-table-other">
      <Actions :timeline="timeline"/>
    </div>


    <div class="gap-content"></div>
  </div>
</template>

<script>
import FilterComponent from "@/components/pagesComponents/brand/FilterComponent";

//import LinkCopier from '@/components/LinkCopier';
import newCampaignBTN from "@/components/pagesComponents/brand/addNewCampaign.vue";
import newBoardBTN from "@/components/pagesComponents/brand/addNewBoard.vue";
// import addCreative from "@/components/pagesComponents/brand/addCreative.vue";
import editCampaign from "@/components/pagesComponents/brand/editCampaign.vue";
import editBrand from "@/components/pagesComponents/dashboard/editBrand.vue"
import viewMI from "@/mixins/viewMI.js";
import copyToClipboard from "@/utils/copyToClipboard";
import Actions from "@/components/pagesComponents/dashboard/Actions.vue"
import EditBoard from "@/components/pagesComponents/brand/editBoard";
import OwnCustomSelect from '@/components/layoutComponents/OwnCustomSelect.vue'
import OwnCustomSelectOption from '@/components/layoutComponents/OwnCustomSelectOption.vue'

export default {
  mixins: [viewMI],
  props: ["brand", "accountView", "designerView","c_slug", "b_slug", "timeline"],
  data: function () {
    return {
      selected_campaign_id: false,
      selected_board_id: false,      
      testingCode: "1234",
      boardUserToNotify:[],      
      boardUserToNotifyCurrent:[],
      copyLinkAnim:false
    };
  },
  components: {
    EditBoard,
    newCampaignBTN,
    newBoardBTN,
    // addCreative,
    editBrand,
    FilterComponent,
    Actions, editCampaign,
    OwnCustomSelect,
    OwnCustomSelectOption
    /*LinkCopier*/
  },
  computed: {
    clients() {
      //console.log('clients', this.brand.user);
      var ret = [];
      if (this.brand.user){        
        for (var i = 0; i < this.brand.user.length; i++) {
          //console.log(this.brand.user[i]);
          if (this.brand.user[i].user_type == 'client')
            ret.push(this.brand.user[i])
        }
      }
      
      return ret;
    },
    notclients() {
      var ret = [];
      if (this.brand.user){
        for (var i = 0; i < this.brand.user.length; i++) {
          //console.log(this.brand.user[i]);
          if (this.brand.user[i].user_type != 'client')
            ret.push(this.brand.user[i])
        }
      }      
      return ret;
    },
    selected_campaign() {
      if (!this.brand.campaign) return false;
      for (var i = 0; i < this.brand.campaign.length; i++) {
        if (
            this.c_slug == this.brand.campaign[i].slug &&
            this.selected_campaign_id == false
        ) {

          return this.brand.campaign[i];
        }
        if (this.selected_campaign_id == false && !this.c_slug) {

          return this.brand.campaign[i];
        }
        if (this.brand.campaign[i].id == this.selected_campaign_id) {
          return this.brand.campaign[i];
        }
      }

      return false;
    },
    selected_board() {
      if (!this.selected_campaign) return false;
      if (!this.selected_campaign.board) return false;
      for (var i = 0; i < this.selected_campaign.board.length; i++) {
        if (
            this.b_slug == this.selected_campaign.board[i].slug &&
            this.selected_board_id == false
        ) {
          return this.selected_campaign.board[i];
        }
        if (this.selected_board_id == false && !this.b_slug) {
          return this.selected_campaign.board[i];
        }
        if (this.selected_campaign.board[i].id == this.selected_board_id)
          return this.selected_campaign.board[i];
      }

      return false;
    }, 
  
    selected_campaign_board(){
      //console.log('filter',this.creative.comment.filter(comment => comment.reply_to == 0));
      // console.log(this.selected_campaign.board);
      var _this= this;
      return this.selected_campaign.board.filter(board => {
        if (_this.$store.state.user.user_type != 'client')
          return true;
        if (!board.creative)
          return false;
        if (board.creative.filter(creative => creative.status == 'live' || creative.status == 'done').length == 0)
          return false;
        return true;
      })
    }
    
  },
  watch:{
    selected_board(){
        this.boardUserToNotify = []
        this.boardUserToNotifyCurrent = []
        this.getUsersToNotify()
    },
  },
  methods: {
    selectFirstBoard () {
     if (this.selected_campaign.board[0]) {
       this.selected_board_id = this.selected_campaign.board[0].id;
     }
    },
    selectBoard (id) {
       this.selected_board_id = id;
    },
    copyLink(path) {
      const baseUrl = window.location.origin;
      copyToClipboard(baseUrl + path);
      this.copyLinkAnim = true
      let _this = this      
      setTimeout(() => {
        _this.copyLinkAnim = false
      }, 2000);
    },
    doneOnBoard(board) {
      if (board.creative) {
        var ret = 0;
        for (var i = 0; i < board.creative.length; i++) {
          if (board.creative[i].status == "done") {
            ret++;
          }
        }
        return ret;
      } else {
        return 0;
      }
    },
    AddNewCrea() {
      this.$refs.add_new_crea.$el.click();
    },
    refreshBrand(successCallback) {
      if (this.$parent.refreshBrand) this.$parent.refreshBrand(successCallback);
    },   
    setUserOnBoard() {

      if (this.boardUserToNotify.length > this.boardUserToNotifyCurrent.length){
        this.addUserToBoardNotify()

      } else if (this.boardUserToNotify.length < this.boardUserToNotifyCurrent.length) {
        this.removeUserToBoardNotify()
      }
            
    },
    addUserToBoardNotify(){
        let _this = this
        let newUserId = this.boardUserToNotify.filter(x => !this.boardUserToNotifyCurrent.includes(x))
        
        if (newUserId.length){
          newUserId = newUserId[0].toString()

          this.post(
              "user_to_board",
              {user_id: newUserId, board_id: _this.selected_board.id},
              {},
              function () {
                _this.refreshBrand();
                _this.notifyUserToConnectBoard(newUserId)
              },
              function (err) {
                console.log(err)            
              }
          );
        }

    },
    removeUserToBoardNotify(){
        let _this = this
        let newUserId = this.boardUserToNotifyCurrent.filter(x => !this.boardUserToNotify.includes(x))


        if (newUserId.length){
          newUserId = newUserId[0].toString()

        _this.delete('user_to_board',
          {
            params:
              {
                where:[
                  ['where','user_id',newUserId],
                  ['where','board_id',_this.selected_board.id]
                ] 
              }
          },function(){
            _this.refreshBrand();
          }, function(err){
            console.log(err)
          });
        }
        

    },
    getUsersToNotify(){
      let _this = this

      _this.get("user_to_board",{ 
            params:{
              where: [['where', 'board_id', _this.selected_board.id]]
            }            
          },function (resp) {
            _this.setBoardUserToNotify(resp.data.user_to_board)
          },
          function (err) {

            _this.$forceUpdate()
            console.log(err)
          }
      );
    },
    setBoardUserToNotify(boardUsers){            
      let _this = this
      let selectedUsers = []

      boardUsers.forEach( element => {         
        var isElementOnBoard = _this.selected_board.user.find( item => parseInt(item.id) == parseInt(element.user_id))        
        if (isElementOnBoard) selectedUsers.push(isElementOnBoard.id)
      })


      this.boardUserToNotifyCurrent = selectedUsers      
      this.boardUserToNotify = selectedUsers.slice()
    },
    notifyUserToConnectBoard(userId){
      let _this = this

      //get the user email address
      _this.get("user",{ 
            params:{
              where: [['where', 'id', userId]],
              select:['email', 'name']
            }            
          },function (resp) {
            // console.log(resp.data.user[0])
            _this.sendEmailAboutNotifyBoard(resp.data.user[0])
          },
          function (err) {            
            console.log(err)
          }
      );

      
    },
    sendEmailAboutNotifyBoard(user){
      let _this = this

      _this.post('emailsender/4/1',{
          to: user.email,
          data_replace:{
              name: user.name,
              assigner_forname: this.$store.state.user.name,              
              board_slug:_this.selected_board.slug,
              campaign: _this.selected_board.campaign.name,
              board: _this.selected_board.name
          }
      },{},function(){
         
      })
    }   
  },
  
};
</script>